import { Tooltip, TooltipContent, TooltipTrigger } from "components/ui/tooltip";
import { TableCell } from "@/components/ui/table";

interface StatementDescriptionCellProps {
  description: string | null;
}

export default function StatementDescriptionCell({
  description,
}: StatementDescriptionCellProps): JSX.Element {
  return (
    <TableCell
      className="font-mono text-xs max-w-[14rem]"
      data-testid="deposit-statement-description"
    >
      {description && (
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="block truncate cursor-default">{description}</span>
          </TooltipTrigger>
          <TooltipContent className="bg-[#141414] text-white font-mono text-xs">
            {description}
          </TooltipContent>
        </Tooltip>
      )}
    </TableCell>
  );
}
